// Defined by the gtag snippet in the document head, and only in production - every read is
// guarded with `typeof`, matching how grecaptcha and the consent banner handle it.
declare var gtag: (command: string, action: string, params?: Record<string, unknown>) => void;

export const LEAD_EVENT = "generate_lead";

export const FUNNEL_EVENT = {
    started: "valuation_funnel_started",
    addressChosen: "valuation_funnel_address_chosen",
    intentChosen: "valuation_funnel_intent_chosen",
    blocked: "valuation_funnel_blocked",
    submitFailed: "valuation_funnel_submit_failed",
} as const;

/**
 * Send a GA4 event, or do nothing.
 *
 * No consent gate here on purpose: the tag runs Consent Mode v2 defaulted to denied, so
 * events from a visitor who has not accepted are sent as cookieless pings rather than
 * suppressed. Gating them here as well would throw away the aggregate view that Consent
 * Mode exists to preserve, and would silently under-count every funnel step.
 *
 * `gtag` is undefined outside production and on any page without the tag, so this is a
 * no-op there rather than a crash.
 */
export const trackEvent = (name: string, params: Record<string, unknown> = {}): void => {
    if (typeof gtag === "undefined") {
        return;
    }
    gtag("event", name, params);
};
